import { noTokenHttpClient } from "../utils/httpClient";
import { post } from "../utils/httpClients-methods";
import { API_URL } from "../utils/AppApiUrl";

export const getCaptchCodeImg = async (baseURL, requestBody) => {
  try {
    const captchResponse = await post(
      noTokenHttpClient,
      `${baseURL}${API_URL.generateCaptchUrl}`,
      JSON.stringify(requestBody)
    );
    if (captchResponse?.status === 200 && captchResponse.data) {
      return captchResponse.data;
    } else {
      return {};
    }
  } catch (err) {
    throw err;
  }
};
export const getCaptchCodeImgForgotPassword = async (baseURL, requestBody) => {
  try {
    const captchResponse = await post(
      noTokenHttpClient,
      `${baseURL}${API_URL.generateCaptchaForgorPassword}`,
      JSON.stringify(requestBody)
    );
    if (captchResponse?.status === 200 && captchResponse.data) {
      return captchResponse.data;
    } else {
      return {};
    }
  } catch (err) {
    throw err;
  }
};
export const getCaptchNewCodeImg = async (baseURL, requestBody) => {
  try {
    const captchResponse = await post(
      noTokenHttpClient,
      `${baseURL}${API_URL.generateNewCaptchUrl}`,
      JSON.stringify(requestBody)
    );

    if (captchResponse?.status === 200 && captchResponse.data) {
      return captchResponse.data;
    } else {
      return {};
    }
  } catch (err) {
    throw err;
  }
};
